import { useCallback, useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { getMediasRanking, MediaRankingApiResponse } from "../../../api/MediasRequests";
import { LoadingState } from "../../../navigation/LoadingState";
import { Interval } from "../../../navigation/tabs/Tabs";
import { Area } from "../../../navigation/tree/Area";
import {Trans} from "react-i18next"
import classes from "../../Statistics.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";

interface IProps {
    area: Area
    nodePath: string,
    startDateTimestamp: number,
    endDateTimestamp: number,
    interval: Interval,
}

export const MediasRanking = (props: IProps) => {

    const [mediasRanking, setMediasRanking] = useState<MediaRankingApiResponse|undefined>(undefined)
    const [loadingState, setLoadingState] = useState<LoadingState>(LoadingState.LOADING)

      
    const loadMediaRanking = async() => {
        setLoadingState(LoadingState.LOADING)
        const mediasRanking = await getMediasRanking(props.startDateTimestamp, props.endDateTimestamp, props.nodePath, props.area.mediaspot?.serial)
        if(mediasRanking.data){
            setMediasRanking(mediasRanking.data)
            setLoadingState(LoadingState.LOADED)
        }else {
            setLoadingState(LoadingState.ERROR)
        }
    }

    // Each time props are updated, reload data
    useEffect(() => {
        loadMediaRanking()
    }, [props.startDateTimestamp, props.endDateTimestamp, props.nodePath, props.interval])

    useEffect(() => {
        ReactTooltip.rebuild();
    });

    return (
        <>
         {
            loadingState === LoadingState.LOADING ?
                <div className={classes.StatisticsLoaderContainer}>
                    <Loader type="Oval" color="#4185F4" height={50} width={50}/>
                </div> : null
        }
        {
            loadingState === LoadingState.ERROR ?
                <div className={classes.StatisticsErrorContainer}>
                    <label><Trans>AnErrorOccurredDuringLoading</Trans>...</label>
                    <br />
                    <button className={classes.RetryButton} onClick={() => loadMediaRanking()}><FontAwesomeIcon icon={faRedo} size={"sm"} color={"#404040"}/>&nbsp;&nbsp;<Trans>Reload</Trans></button>
                </div> : null
        }
            
        {
            loadingState === LoadingState.LOADED && mediasRanking ?

                mediasRanking.length === 0 ? <div className={classes.StatisticsNoDataContainer}>
                    <label><Trans>NoDataOnThisPeriod</Trans></label>
                </div> :

                <table>
                    <thead>
                        <tr>
                            <th>Média</th>
                            <th>Nombre de lectures</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            mediasRanking.map(mediaRanking => {
                                const mediaFileName = mediaRanking.media.split("/")[mediaRanking.media.split("/").length - 1]
                                let reformattedName = mediaFileName.replaceAll("_", " ").replace(".mp4", "").toLowerCase()
                                reformattedName = reformattedName.charAt(0).toUpperCase() + reformattedName.slice(1);

                                return (
                                    <tr>
                                        <td data-event="click" data-text-color={"#000000"} data-place={"bottom"} data-class={classes.tooltip} data-border={true} data-border-color={"#c3bdb9"} data-background-color={"white"} data-multiline={false} data-tip={mediaRanking.media} style={{cursor: "help"}}>{reformattedName}</td>
                                        <td>{mediaRanking.count}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                : undefined
            }
        </>
    )
}